export default __webpack_public_path__ + "static/media/typescript.16240f48.png";